<script lang="ts">
  interface Props {
    size?: 16 | 20;
  }

  let { size = 16 }: Props = $props();
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  id="eEkonomi-logomark"
  width={size}
  height={size}
  viewBox="0 0 96 96"
>
  <defs>
    <clipPath id="clippath">
      <rect x="-6.86" y="-6.86" width="109.71" height="109.71" fill="none" />
    </clipPath>
    <linearGradient
      id="linear-gradient"
      x1="81.6"
      y1="1024.95"
      x2="32.59"
      y2="981.93"
      gradientTransform="translate(0 1050) scale(1 -1)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset=".04" stop-color="#ffedeb" />
      <stop offset=".48" stop-color="#fe9388" />
      <stop offset=".98" stop-color="#eb0000" />
    </linearGradient>
    <linearGradient
      id="linear-gradient-2"
      x1="84.14"
      y1="1031.83"
      x2="41.42"
      y2="1016.22"
      gradientTransform="translate(0 1050) scale(1 -1)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset=".08" stop-color="#fe796b" />
      <stop offset=".88" stop-color="#ffb5ae" />
    </linearGradient>
    <radialGradient
      id="radial-gradient"
      cx="-14.05"
      cy="1064.56"
      fx="-14.05"
      fy="1064.56"
      r=".41"
      gradientTransform="translate(-63850.32 -139598.84) rotate(155.98) scale(110.94 -144.24)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset=".03" stop-color="#8c57c1" />
      <stop offset=".86" stop-color="#ffedeb" stop-opacity="0" />
    </radialGradient>
    <linearGradient
      id="linear-gradient-3"
      x1="20.6"
      y1="1018.7"
      x2="30.41"
      y2="974.15"
      gradientTransform="translate(0 1050) scale(1 -1)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#c497e2" stop-opacity=".2" />
      <stop offset="1" stop-color="#eb0000" />
    </linearGradient>
    <linearGradient
      id="linear-gradient-4"
      x1="52.92"
      y1="1015.34"
      x2="45.47"
      y2="977.45"
      gradientTransform="translate(0 1050) scale(1 -1)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#fe796b" />
      <stop offset=".29" stop-color="#f56262" />
      <stop offset="1" stop-color="#eb0000" />
    </linearGradient>
  </defs>
  <g clip-path="url(#clippath)">
    <g>
      <path
        d="m80.1,3c1.78,22.93-35.57,10.32-50.82,34.31-9.24,14.57-9.16,32.41,2.39,55.62.05.09.17.04.14-.05-4.52-11.51,4.31-16.13,4.56-16.26,10.28-5.98,30.43-3.73,41.29-12.82,6.88-5.77,8.87-14.74,8.91-23.67-.04-7.45-2.11-24.81-6.47-37.14Z"
        fill="url(#linear-gradient)"
      />
      <path
        d="m78.9,35.59c-10.36,8.39-23.05,2.83-34.7-2.21-3.15-1.35-6.01-2.37-8.75-3.11,17.33-14.45,46.22-7,44.65-27.27,1.62,4.55,2.9,9.75,3.9,14.9,1.19,6.18-.21,13.14-5.1,17.69Z"
        fill="url(#linear-gradient-2)"
      />
      <path
        d="m78.9,35.59c-10.36,8.39-23.05,2.83-34.7-2.21-3.15-1.35-6.01-2.37-8.75-3.11,17.33-14.45,46.22-7,44.65-27.27,1.62,4.55,2.9,9.75,3.9,14.9,1.19,6.18-.21,13.14-5.1,17.69Z"
        fill="url(#radial-gradient)"
        fill-opacity=".4"
      />
      <path
        d="m29.28,37.31c-9.24,14.58-9.16,32.42,2.4,55.64-.04-.04-.11-.15-.26-.37-1.51-2.22-9.21-13.7-15.95-26.23C2.96,43.17,10,23.43,35.46,30.27c-2.28,1.92-4.39,4.22-6.18,7.04Z"
        fill="url(#linear-gradient-3)"
      />
      <path
        d="m78.9,35.59c-.62.61-1.87,1.56-3.15,2.25-7.05,3.89-22.72,7.25-33.99,18.38-16.45,16.24-10.97,33.8-10.04,36.39.08.22.11.34.02.35-.06,0-.1-.13-.18-.28-11.46-23.11-11.57-40.85-2.36-55.38,1.78-2.83,3.94-5.12,6.26-7.04,2.69.74,5.6,1.72,8.75,3.07,11.69,5.08,24.38,10.65,34.7,2.25Z"
        fill="url(#linear-gradient-4)"
      />
    </g>
  </g>
</svg>
